function isNullish(value) {
  return value === null || value === void 0;
}

export { isNullish as i };
//# sourceMappingURL=nullish.js.map
